module.exports = __webpack_public_path__ + "img/LTE:OK - WLAN:OK - PopOver.b587f2b0.jpg";